import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Collapse,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import toast from "react-hot-toast";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import { getVendorsList } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import formatDateAndTime from "../../common/formatDateAndTime";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useSelector } from "react-redux";
import { FileText, FileVideo, FileImage, File } from "lucide-react";
import HeicPreview from "../../common/HeicPreview";

function createData(
  id,
  attachments,
  city,
  serviceDate,
  ododmeterReading,
  description,
  isRotated,
  isAlignmentDone,
  isBalancingDone,
  // isPaymentPending,
  costToCompany,
  issueId,
  vendorName,

  // GST Details
  sgst,
  cgst,
  totalTax,

  // Cost Details
  labourCost,
  totalCost,

  // GST Percentages
  sgstPercentage,
  cgstPercentage,
  totalTaxPercentage,

  // Discount Details
  discountAmount,
  discountPercentage,
) {
  return {
    id,
    attachments,
    city,
    serviceDate,
    ododmeterReading,
    description,
    isRotated,
    isAlignmentDone,
    isBalancingDone,
    // isPaymentPending,
    costToCompany,
    issueId,
    vendorName,

    // GST Details
    sgst,
    cgst,
    totalTax,

    // Cost Details
    labourCost,
    totalCost,

    // GST Percentages
    sgstPercentage,
    cgstPercentage,
    totalTaxPercentage,

    // Discount Details
    discountAmount,
    discountPercentage,
  };
}

const steps = ["Wheel Alignment Log Details"];

const Wheelalignmentdetails = ({ workOrderDetail }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const cities = useSelector((state) => state?.cities?.citiesData);
  const catalogValues = JSON.parse(localStorage.getItem("catalogValues"));

  const clutchPartName = catalogValues?.clutchPartName || {};
  delete clutchPartName?.inverted;
  const clutchPartSource = catalogValues?.clutchPartSource || {};
  delete clutchPartSource?.inverted;
  const clutchWorkType = catalogValues?.clutchWorkType || {};
  delete clutchWorkType?.inverted;
  const [activeStep, setActiveStep] = useState(0);
  const [hideTextfields, setHideTestFields] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [clutchLogs, setClutchLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [myIssues, setMyIssuesDetails] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editWheelAlignmentId, setEditWheelAlignmentId] = useState(null);
  const [uploadedImages, setUploadedImages] = useState(null);
  const workorderStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;
  const validation = [
    Number(workorderStatus?.inverted?.serviceCompleted),
    Number(workorderStatus?.inverted?.enrouteToHub),
    Number(workorderStatus?.inverted?.billingApproved),
    Number(workorderStatus?.inverted?.billingApprovalRequest),
  ].includes(Number(workOrderDetail?.serviceStatus));

  const getVehicleIssues = async (vehicleID) => {
    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehicleissues?limit=${200}&offset=${0}&vehicleId=${vehicleID}`,
        {
          method: "GET",
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setMyIssuesDetails(data?.entities?.rows || []);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVendorListAPI();
  }, []);

  useEffect(() => {
    if (workOrderDetail?.id) {
      getVehicleIssues(workOrderDetail.id);
    }
  }, [workOrderDetail]);

  const getVendorListAPI = async (value) => {
    const apiDetails = await getVendorsList(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setVendors(data?.entities?.rows || []);
  };

  const formatDateToInput = (dateString) => {
    if (!dateString) return "";

    if (typeof dateString !== "string") {
      return "";
    }

    const normalizedDate = dateString.trim();
    if (normalizedDate === "-") return "";

    const isoDate = normalizedDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoDate) {
      return `${isoDate[1]}-${isoDate[2]}-${isoDate[3]}`;
    }

    const numericDate = normalizedDate.match(/^(\d{2})[-/](\d{2})[-/](\d{4})/);
    if (numericDate) {
      return `${numericDate[3]}-${numericDate[2]}-${numericDate[1]}`;
    }

    const months = {
      jan: "01",
      feb: "02",
      mar: "03",
      apr: "04",
      may: "05",
      jun: "06",
      jul: "07",
      aug: "08",
      sep: "09",
      oct: "10",
      nov: "11",
      dec: "12",
    };

    const parts = normalizedDate.split(" ");
    const dateParts = parts[0].split("-");

    if (dateParts.length === 3) {
      const day = dateParts[0].padStart(2, "0");
      const month = months[dateParts[1]?.toLowerCase()] || dateParts[1];
      const year = dateParts[2];
      return `${year}-${month}-${day}`;
    }

    return dateString;
  };

  const handleEdit = (row) => {
    setHideTestFields(true);
    setIsEdit(true);
    setEditWheelAlignmentId(row?.id || null);

    const rawLog = clutchLogs.find((item) => item.id === row?.id);

    let parsedAttachments = [];
    try {
      const attachmentsData =
        row?.attachments ||
        rawLog?.reportAttachments ||
        rawLog?.attachments ||
        [];

      if (typeof attachmentsData === "string") {
        parsedAttachments = JSON.parse(attachmentsData);
      } else if (Array.isArray(attachmentsData)) {
        parsedAttachments = attachmentsData;
      }
    } catch (e) {
      parsedAttachments = [];
    }

    setForm({
      wheelLogDetails: {
        serviceDate: rawLog?.serviceDate || row?.serviceDate || "",
        odometerReading:
          rawLog?.ododmeterReading ?? row?.ododmeterReading ?? "",
        cityId: rawLog?.cityId ?? row?.cityId ?? "",
        reportAttachments: parsedAttachments,
        attachments: parsedAttachments,
        description: rawLog?.description ?? row?.description ?? "",
        vendorId: rawLog?.vendorId ?? row?.vendorId ?? "",
        issueId: rawLog?.issueId ?? row?.issueId ?? "",
        vendorName: rawLog?.vendorName ?? row?.vendorName ?? "",
        vendorMobile: rawLog?.vendorMobile ?? row?.vendorMobile ?? "",
        vendorEmail: rawLog?.vendorEmail ?? row?.vendorEmail ?? "",
        isRotated:
          rawLog?.isRotated !== undefined
            ? rawLog.isRotated
            : (row?.isRotated ?? ""),
        isAlignmentDone:
          rawLog?.isAlignmentDone !== undefined
            ? rawLog.isAlignmentDone
            : (row?.isAlignmentDone ?? ""),
        isBalancingDone:
          rawLog?.isBalancingDone !== undefined
            ? rawLog.isBalancingDone
            : (row?.isBalancingDone ?? ""),
        isPaymentPending:
          rawLog?.isPaymentPending !== undefined
            ? rawLog.isPaymentPending
            : (row?.isPaymentPending ?? ""),
        costToCompany: rawLog?.costToCompany ?? row?.costToCompany ?? "",
        labourCost: rawLog?.labourCost ?? row?.labourCost ?? "",
        totalCost: rawLog?.totalCost ?? row?.totalCost ?? "",
        discountAmount: rawLog?.discountAmount ?? row?.discountAmount ?? "",
        discountPercentage:
          rawLog?.discountPercentage ?? row?.discountPercentage ?? "",
        cgst: rawLog?.cgst ?? row?.cgst ?? "",
        cgstPercentage: rawLog?.cgstPercentage ?? row?.cgstPercentage ?? "",
        sgst: rawLog?.sgst ?? row?.sgst ?? "",
        sgstPercentage: rawLog?.sgstPercentage ?? row?.sgstPercentage ?? "",
        totalTax: rawLog?.totalTax ?? row?.totalTax ?? "",
        totalTaxPercentage:
          rawLog?.totalTaxPercentage ?? row?.totalTaxPercentage ?? "",
      },
    });

    setUploadedImages(parsedAttachments);

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const [form, setForm] = useState({
    wheelLogDetails: {
      serviceDate: null,
      ododmeterReading: null,
      cityId: null,
      reportAttachments: null,
      attachments: [],
      description: null,
      vendorId: null,
      issueId: null,
      vendorName: null,
      vendorMobile: null,
      vendorEmail: null,
      isRotated: null,
      isAlignmentDone: null,
      isBalancingDone: null,
      isPaymentPending: null,
      costToCompany: null,
      labourCost: null,
      totalCost: null,

      // Discount
      discountAmount: null,
      discountPercentage: null,

      // CGST
      cgst: null,
      cgstPercentage: null,

      // SGST
      sgst: null,
      sgstPercentage: null,

      // Total Tax
      totalTax: null,
      totalTaxPercentage: null,
    },
  });

  const handleServiceAttachment = async (files) => {
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const uploaded = res?.uploaded;

    setForm((prev) => ({
      ...prev,
      wheelLogDetails: {
        ...prev.wheelLogDetails,
        reportAttachments: [
          ...(prev.wheelLogDetails.reportAttachments || []),
          ...uploaded,
        ],
      },
    }));
  };

  const handleServiceChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      wheelLogDetails: {
        ...prev.wheelLogDetails,
        [field]: value,
      },
    }));
  };

  const handleSubmit = async () => {
    const { wheelLogDetails } = form;

    // if (!wheelLogDetails?.cityId) {
    //   return toast.error("Please select City");
    // }

    // if (!wheelLogDetails?.serviceDate) {
    //   return toast.error("Please Service Date");
    // }

    if (!wheelLogDetails?.odometerReading) {
      return toast.error("Please enter odometer reading");
    }

    // if (!wheelLogDetails?.vendorId) {
    //   return toast.error("Please Select Vendor");
    // }

    const payload = {
      serviceDate: workOrderDetail?.createdAt,
      ododmeterReading: form?.wheelLogDetails?.odometerReading,
      cityId: form?.wheelLogDetails?.cityId || workOrderDetail?.cityId,
      reportAttachments: JSON.stringify(
        form?.wheelLogDetails?.reportAttachments,
      ),
      attachments: form?.wheelLogDetails?.attachments,
      description: form?.wheelLogDetails?.description,
      isRotated: form?.wheelLogDetails?.isRotated,
      isAlignmentDone: form?.wheelLogDetails?.isAlignmentDone,
      isBalancingDone: form?.wheelLogDetails?.isBalancingDone,
      isPaymentPending: form?.wheelLogDetails?.isPaymentPending,
      costToCompany: parseFloat(form?.wheelLogDetails?.costToCompany) || 0,
      vehicleId: workOrderDetail?.vehicleId,
      serviceLogId: workOrderDetail?.id,
      isArchieved: false,
      sgst: form?.wheelLogDetails?.sgst,
      cgst: form?.wheelLogDetails?.cgst,
      totalTax: form?.wheelLogDetails?.totalTax,
      labourCost: form?.wheelLogDetails?.labourCost,
      totalCost: form?.wheelLogDetails?.totalCost,
      sgstPercentage: form?.wheelLogDetails?.sgstPercentage,
      cgstPercentage: form?.wheelLogDetails?.cgstPercentage,
      totalTaxPercentage: form?.wheelLogDetails?.totalTaxPercentage,
      discountAmount: form?.wheelLogDetails?.discountAmount,
      discountPercentage: form?.wheelLogDetails?.discountPercentage,
      serviceCode: workOrderDetail?.serviceCode,
    };

    try {
      const res = await fetch(`${apiUrl}/api/wheelalignmentlogs`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("Wheel Alignment Log Added Successfully 🎉");

        setForm({
          wheelLogDetails: {
            serviceDate: "",
            odometerReading: "",
            cityId: "",

            reportAttachments: [],
            attachments: [],

            description: "",

            vendorId: "",
            issueId: "",

            vendorName: "",
            vendorMobile: "",
            vendorEmail: "",

            isRotated: "",
            isAlignmentDone: "",
            isBalancingDone: "",
            isPaymentPending: "",

            // Cost
            costToCompany: "",
            labourCost: "",
            totalCost: "",

            // Discount
            discountAmount: "",
            discountPercentage: "",

            // CGST
            cgst: "",
            cgstPercentage: "",

            // SGST
            sgst: "",
            sgstPercentage: "",

            // Total Tax
            totalTax: "",
            totalTaxPercentage: "",
          },
        });

        setActiveStep(0);
        await getWheelAlignmentAPI(workOrderDetail?.id);
      } else {
        toast.error(data?.msg, {
          position: "top-end",
          style: {
            background: "red",
            color: "white",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    if (workOrderDetail?.id) {
      getWheelAlignmentAPI(workOrderDetail?.id);
    }
  }, [workOrderDetail]);

  const getWheelAlignmentAPI = async (id, page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/wheelalignmentlogs?serviceLogId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const data = await response.json();

      console.log("Wheel Alignment Logs Data:", data?.entities?.rows);

      if (data?.statusCode === "0100") {
        setClutchLogs(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  const rows =
    (clutchLogs &&
      clutchLogs?.map((item) =>
        createData(
          item?.id,
          item?.reportAttachments,
          cities[item?.cityId],
          item?.serviceDate,
          item?.ododmeterReading,
          item?.description,
          item?.isRotated ? "True" : "False",
          item?.isAlignmentDone ? "True" : "False",
          item?.isBalancingDone ? "True" : "False",

          // Cost to Company
          item?.costToCompany || 0,

          // Issue & Vendor
          myIssues.filter((issue) => issue?.id === item?.issueId)[0]?.code,
          vendors.filter((vendor) => vendor?.id === item?.vendorId)[0]?.name,

          // GST Details
          item?.sgst || 0,
          item?.cgst || 0,
          item?.totalTax || 0,

          // Cost Details
          item?.labourCost || 0,
          item?.totalCost || 0,

          // GST Percentages
          item?.sgstPercentage || 0,
          item?.cgstPercentage || 0,
          item?.totalTaxPercentage || 0,

          // Discount Details
          item?.discountAmount || 0,
          item?.discountPercentage || 0,
        ),
      )) ||
    [];

  const getFileType = (url = "") => {
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "webp", "gif", "avif", "svg"].includes(ext))
      return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (ext === "pdf") return "pdf";
    if (ext === "heic") return "heic";
    if (["doc", "docx", "xls", "xlsx"].includes(ext)) return "doc";

    return "file";
  };

  const handleAddNewBattery = async () => {
    let payload = {};
    if (editWheelAlignmentId) {
      payload = {
        id: editWheelAlignmentId,
        serviceDate: workOrderDetail?.createdAt,
        ododmeterReading: form?.wheelLogDetails?.odometerReading,
        cityId: form?.wheelLogDetails?.cityId || workOrderDetail?.cityId,
        reportAttachments: JSON.stringify(
          form?.wheelLogDetails?.reportAttachments || [],
        ),
        attachments: form?.wheelLogDetails?.attachments || [],
        description: form?.wheelLogDetails?.description,
        isRotated: form?.wheelLogDetails?.isRotated,
        isAlignmentDone: form?.wheelLogDetails?.isAlignmentDone,
        isBalancingDone: form?.wheelLogDetails?.isBalancingDone,
        isPaymentPending: form?.wheelLogDetails?.isPaymentPending,
        costToCompany: parseFloat(form?.wheelLogDetails?.costToCompany) || 0,
        vehicleId: workOrderDetail?.vehicleId,
        serviceLogId: workOrderDetail?.id,
        isArchieved: false,
        sgst: form?.wheelLogDetails?.sgst,
        cgst: form?.wheelLogDetails?.cgst,
        totalTax: form?.wheelLogDetails?.totalTax,
        labourCost: form?.wheelLogDetails?.labourCost,
        totalCost: form?.wheelLogDetails?.totalCost,
        sgstPercentage: form?.wheelLogDetails?.sgstPercentage,
        cgstPercentage: form?.wheelLogDetails?.cgstPercentage,
        totalTaxPercentage: form?.wheelLogDetails?.totalTaxPercentage,
        discountAmount: form?.wheelLogDetails?.discountAmount,
        discountPercentage: form?.wheelLogDetails?.discountPercentage,
        serviceCode: workOrderDetail?.serviceCode,
      };
    } else {
      payload = {
        serviceDate: workOrderDetail?.createdAt,
        ododmeterReading: form?.wheelLogDetails?.odometerReading,
        cityId: form?.wheelLogDetails?.cityId || workOrderDetail?.cityId,
        reportAttachments: JSON.stringify(
          form?.wheelLogDetails?.reportAttachments || [],
        ),
        attachments: form?.wheelLogDetails?.attachments || [],
        description: form?.wheelLogDetails?.description,
        isRotated: form?.wheelLogDetails?.isRotated,
        isAlignmentDone: form?.wheelLogDetails?.isAlignmentDone,
        isBalancingDone: form?.wheelLogDetails?.isBalancingDone,
        isPaymentPending: form?.wheelLogDetails?.isPaymentPending,
        costToCompany: parseFloat(form?.wheelLogDetails?.costToCompany) || 0,
        vehicleId: workOrderDetail?.vehicleId,
        serviceLogId: workOrderDetail?.id,
        isArchieved: false,
        sgst: form?.wheelLogDetails?.sgst,
        cgst: form?.wheelLogDetails?.cgst,
        totalTax: form?.wheelLogDetails?.totalTax,
        labourCost: form?.wheelLogDetails?.labourCost,
        totalCost: form?.wheelLogDetails?.totalCost,
        sgstPercentage: form?.wheelLogDetails?.sgstPercentage,
        cgstPercentage: form?.wheelLogDetails?.cgstPercentage,
        totalTaxPercentage: form?.wheelLogDetails?.totalTaxPercentage,
        discountAmount: form?.wheelLogDetails?.discountAmount,
        discountPercentage: form?.wheelLogDetails?.discountPercentage,
        serviceCode: workOrderDetail?.serviceCode,
      };
    }

    try {
      const url = `${apiUrl}/api/wheelalignmentlogs`;

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success(
          editWheelAlignmentId
            ? "Wheel Alignment Log Updated Successfully 🎉"
            : "Wheel Alignment Log Added Successfully 🎉",
        );

        setForm({
          wheelLogDetails: {
            serviceDate: "",
            odometerReading: "",
            cityId: "",
            reportAttachments: [],
            attachments: [],
            description: "",
            vendorId: "",
            issueId: "",
            vendorName: "",
            vendorMobile: "",
            vendorEmail: "",
            isRotated: "",
            isAlignmentDone: "",
            isBalancingDone: "",
            isPaymentPending: "",
            costToCompany: "",
            labourCost: "",
            totalCost: "",
            discountAmount: "",
            discountPercentage: "",
            cgst: "",
            cgstPercentage: "",
            sgst: "",
            sgstPercentage: "",
            totalTax: "",
            totalTaxPercentage: "",
          },
        });

        setUploadedImages(null);
        setIsEdit(false);
        setEditWheelAlignmentId(null);
        setActiveStep(0);
        await getWheelAlignmentAPI(workOrderDetail?.id);
      } else {
        toast.error(data?.msg || "Something went wrong", {
          position: "top-end",
          style: {
            background: "red",
            color: "white",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      }
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <div className="flex justify-between p-6 mt-6">
        <h1 className="text-lg font-semibold">Add Wheel Alignment Log</h1>

        {hideTextfields ? (
          <CloseIcon
            onClick={() => setHideTestFields(false)}
            className="cursor-pointer"
          />
        ) : (
          <AddCircleOutlineIcon
            onClick={() => setHideTestFields(true)}
            className="cursor-pointer"
          />
        )}
      </div>

      {hideTextfields && (
        <div className="p-6">
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((step) => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {/* STEP 1 */}

          {activeStep === 0 && (
            <div className="grid grid-cols-3 gap-6 mt-6">
              {/* <FormControl>
                <InputLabel>Select City</InputLabel>
                <Select
                  value={form.wheelLogDetails.cityId}
                  label="Clutch Work Type"
                  onChange={(e) =>
                    handleServiceChange("cityId", e.target.value)
                  }
                >
                  {Object.entries(cities).map(([k, v]) => (
                    <MenuItem key={k} value={k}>
                      {v}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}

              {/* <TextField
                type="date"
                label="Service Date"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.serviceDate}
                onChange={(e) =>
                  handleServiceChange("serviceDate", e.target.value)
                }
              /> */}

              <TextField
                type="number"
                label="Odometer Reading"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.odometerReading}
                onChange={(e) =>
                  handleServiceChange("odometerReading", e.target.value)
                }
              />

              <TextField
                type="text"
                label="Description"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.description}
                onChange={(e) =>
                  handleServiceChange("description", e.target.value)
                }
              />
              {/* 
              <FormControl fullWidth>
                <InputLabel>Select Vendor</InputLabel>
                <Select
                  value={form.wheelLogDetails.vendorId}
                  label="Select Vendor"
                  onChange={(e) =>
                    handleServiceChange("vendorId", e.target.value)
                  }
                >
                  {vendors?.map((vendor) => (
                    <MenuItem key={vendor.id} value={vendor.id}>
                      {vendor.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}

              <FormControl fullWidth>
                <InputLabel>Is Rotated</InputLabel>
                <Select
                  value={form.wheelLogDetails.isRotated}
                  label="Is Rotated"
                  onChange={(e) =>
                    handleServiceChange("isRotated", e.target.value)
                  }
                >
                  <MenuItem key={true} value={true}>
                    True
                  </MenuItem>
                  <MenuItem key={false} value={false}>
                    False
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel>Is Alignment Done</InputLabel>
                <Select
                  value={form.wheelLogDetails.isAlignmentDone}
                  label="Is Alignment Done"
                  onChange={(e) =>
                    handleServiceChange("isAlignmentDone", e.target.value)
                  }
                >
                  <MenuItem key={true} value={true}>
                    True
                  </MenuItem>
                  <MenuItem key={false} value={false}>
                    False
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel>Is Balancing Done</InputLabel>
                <Select
                  value={form.wheelLogDetails.isBalancingDone}
                  label="Is Balancing Done"
                  onChange={(e) =>
                    handleServiceChange("isBalancingDone", e.target.value)
                  }
                >
                  <MenuItem key={true} value={true}>
                    True
                  </MenuItem>
                  <MenuItem key={false} value={false}>
                    False
                  </MenuItem>
                </Select>
              </FormControl>

              {/* <FormControl fullWidth>
                <InputLabel>Is Payment Pending</InputLabel>
                <Select
                  value={form.wheelLogDetails.isPaymentPending}
                  label="Is Payment Pending"
                  onChange={(e) =>
                    handleServiceChange("isPaymentPending", e.target.value)
                  }
                >
                  <MenuItem key={true} value={true}>
                    True
                  </MenuItem>
                  <MenuItem key={false} value={false}>
                    False
                  </MenuItem>
                </Select>
              </FormControl> */}

              <TextField
                type="number"
                label="Cost to Company"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.costToCompany}
                onChange={(e) =>
                  handleServiceChange("costToCompany", e.target.value)
                }
              />

              <TextField
                type="number"
                label="CGST Amount"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.cgst}
                onChange={(e) => handleServiceChange("cgst", e.target.value)}
              />

              <TextField
                type="number"
                label="CGST Percentage"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.cgstPercentage}
                onChange={(e) =>
                  handleServiceChange("cgstPercentage", e.target.value)
                }
              />

              <TextField
                type="number"
                label="SGST Amount"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.sgst}
                onChange={(e) => handleServiceChange("sgst", e.target.value)}
              />

              <TextField
                type="number"
                label="SGST Percentage"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.sgstPercentage}
                onChange={(e) =>
                  handleServiceChange("sgstPercentage", e.target.value)
                }
              />

              <TextField
                type="number"
                label="Total Tax"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.totalTax}
                onChange={(e) =>
                  handleServiceChange("totalTax", e.target.value)
                }
              />

              <TextField
                type="number"
                label="Total Tax Percentagey"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.totalTaxPercentage}
                onChange={(e) =>
                  handleServiceChange("totalTaxPercentage", e.target.value)
                }
              />

              <TextField
                type="number"
                label="Labour Cost"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.labourCost}
                onChange={(e) =>
                  handleServiceChange("labourCost", e.target.value)
                }
              />

              <TextField
                type="number"
                label="Total Cost"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.totalCost}
                onChange={(e) =>
                  handleServiceChange("totalCost", e.target.value)
                }
              />

              <TextField
                type="number"
                label="Discount Amount"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.discountAmount}
                onChange={(e) =>
                  handleServiceChange("discountAmount", e.target.value)
                }
              />

              <TextField
                type="number"
                label="Discount Percentage"
                InputLabelProps={{ shrink: true }}
                value={form.wheelLogDetails.discountPercentage}
                onChange={(e) =>
                  handleServiceChange("discountPercentage", e.target.value)
                }
              />

              {/* <FormControl fullWidth>
                <InputLabel>Select Issue</InputLabel>
                <Select
                  value={form.wheelLogDetails.issueId}
                  label="Select Vendor"
                  onChange={(e) =>
                    handleServiceChange("issueId", e.target.value)
                  }
                >
                  {myIssues?.map((issue) => (
                    <MenuItem key={issue.id} value={issue.id}>
                      {issue.code}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}

              <div className="col-span-3">
                <label className="font-semibold mb-2 block">
                  Wheel Alignment Attachments
                </label>

                <Button component="label" variant="outlined">
                  Upload Files
                  <input
                    hidden
                    type="file"
                    multiple
                    onChange={(e) => handleServiceAttachment(e.target.files)}
                  />
                </Button>

                <div className="flex gap-3 mt-3 flex-wrap">
                  {form.wheelLogDetails.reportAttachments?.map((img, i) => (
                    <img
                      key={i}
                      src={img?.url}
                      className="w-20 h-20 object-cover rounded border"
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className="flex justify-end gap-4 mt-6">
            {activeStep > 0 && (
              <Button onClick={() => setActiveStep(activeStep - 1)}>
                Back
              </Button>
            )}

            {activeStep < steps.length - 1 && (
              <Button
                variant="contained"
                onClick={() => setActiveStep(activeStep + 1)}
              >
                Next
              </Button>
            )}

            {activeStep === steps.length - 1 && (
              <Button
                variant="contained"
                onClick={() => {
                  // if (!validateForm()) return;
                  handleAddNewBattery();
                }}
              >
                {isEdit ? "Update" : "+ Add"}
              </Button>
            )}
          </div>
        </div>
      )}

      <div className="p-4">
        <TableContainer
          component={Paper}
          sx={{ width: "100%", overflowX: "auto" }}
        >
          <Table sx={{ width: "100%", minWidth: 2200 }}>
            <TableHead>
              <TableRow>
                <TableCell>Attachments</TableCell>
                <TableCell>Service Date</TableCell>
                <TableCell>Odometer Reading</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Is Rotated</TableCell>
                <TableCell>Is Alignment Done</TableCell>
                <TableCell>Is Balancing Done</TableCell>

                <TableCell>Cost to Company</TableCell>
                <TableCell>Labour Cost</TableCell>

                <TableCell>Discount Amount</TableCell>
                <TableCell>Discount %</TableCell>

                <TableCell>CGST</TableCell>
                <TableCell>CGST %</TableCell>

                <TableCell>SGST</TableCell>
                <TableCell>SGST %</TableCell>

                <TableCell>Total Tax</TableCell>
                <TableCell>Total Tax %</TableCell>

                <TableCell>Total Cost</TableCell>
                <TableCell>Edit</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.length ? (
                <>
                  {rows.map((r, index) => (
                    <React.Fragment key={index}>
                      <TableRow>
                        {/* Attachments */}
                        <TableCell>
                          <IconButton
                            size="small"
                            onClick={() => setOpen(open === index ? -1 : index)}
                          >
                            {open === index ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </IconButton>
                        </TableCell>

                        {/* Basic Details */}
                        <TableCell>{r.serviceDate || "-"}</TableCell>

                        <TableCell>{r.ododmeterReading || "-"}</TableCell>

                        <TableCell
                          sx={{
                            color: "green",
                            fontWeight: "bold",
                          }}
                        >
                          {r.description || "-"}
                        </TableCell>

                        {/* Status */}
                        <TableCell
                          sx={{
                            backgroundColor:
                              r.isRotated === "True"
                                ? "lightgreen"
                                : "lightcoral",
                            color: "black",
                          }}
                        >
                          {r.isRotated || "-"}
                        </TableCell>

                        <TableCell
                          sx={{
                            backgroundColor:
                              r.isAlignmentDone === "True"
                                ? "lightgreen"
                                : "lightcoral",
                            color: "black",
                          }}
                        >
                          {r.isAlignmentDone || "-"}
                        </TableCell>

                        <TableCell
                          sx={{
                            backgroundColor:
                              r.isBalancingDone === "True"
                                ? "lightgreen"
                                : "lightcoral",
                            color: "black",
                          }}
                        >
                          {r.isBalancingDone || "-"}
                        </TableCell>

                        {/* Cost to Company */}
                        <TableCell>
                          ₹
                          {Number(r.costToCompany || 0).toLocaleString("en-IN")}
                        </TableCell>

                        {/* Labour Cost */}
                        <TableCell>
                          ₹{Number(r.labourCost || 0).toLocaleString("en-IN")}
                        </TableCell>

                        {/* Discount */}
                        <TableCell>
                          ₹
                          {Number(r.discountAmount || 0).toLocaleString(
                            "en-IN",
                          )}
                        </TableCell>

                        <TableCell>
                          {Number(r.discountPercentage || 0)}%
                        </TableCell>

                        {/* CGST */}
                        <TableCell>
                          ₹{Number(r.cgst || 0).toLocaleString("en-IN")}
                        </TableCell>

                        <TableCell>{Number(r.cgstPercentage || 0)}%</TableCell>

                        {/* SGST */}
                        <TableCell>
                          ₹{Number(r.sgst || 0).toLocaleString("en-IN")}
                        </TableCell>

                        <TableCell>{Number(r.sgstPercentage || 0)}%</TableCell>

                        {/* Total Tax */}
                        <TableCell>
                          ₹{Number(r.totalTax || 0).toLocaleString("en-IN")}
                        </TableCell>

                        <TableCell>
                          {Number(r.totalTaxPercentage || 0)}%
                        </TableCell>

                        {/* Total Cost */}
                        <TableCell sx={{ fontWeight: "bold" }}>
                          ₹{Number(r.totalCost || 0).toLocaleString("en-IN")}
                        </TableCell>
                        {validation ? null : (
                          <TableCell>
                            {" "}
                            <Button
                              sx={{
                                color: "white",
                                bgcolor: "#1227e6",
                                fontWeight: 700,
                                whiteSpace: "nowrap",
                                "&:hover": { bgcolor: "#0d1eb8" },
                              }}
                              onClick={() => handleEdit(r)}
                            >
                              {" "}
                              Edit{" "}
                            </Button>{" "}
                          </TableCell>
                        )}
                      </TableRow>

                      {/* Attachments Collapse */}
                      <TableRow>
                        <TableCell colSpan={18} sx={{ p: 0 }}>
                          <Collapse in={open === index}>
                            <Box sx={{ p: 2 }}>
                              <div className="flex gap-2 flex-wrap">
                                {r?.attachments &&
                                  JSON.parse(r.attachments)?.map(
                                    (item, attachmentIndex) => {
                                      const url =
                                        typeof item === "string"
                                          ? item
                                          : item?.url;

                                      if (!url) return null;

                                      const type = getFileType(url);

                                      return (
                                        <div
                                          key={attachmentIndex}
                                          className="border rounded-xl p-3 shadow hover:shadow-lg transition bg-white flex flex-col items-center justify-between gap-3"
                                        >
                                          <div className="flex items-center justify-center">
                                            {type === "image" && (
                                              <img
                                                src={url}
                                                alt="Preview"
                                                className="w-28 h-24 object-cover rounded-lg cursor-pointer"
                                              />
                                            )}

                                            {type === "heic" && (
                                              <HeicPreview
                                                url={url}
                                                alt="Preview"
                                                className="w-28 h-24 object-cover rounded-lg cursor-pointer"
                                              />
                                            )}

                                            {type === "video" && (
                                              <video
                                                src={url}
                                                controls
                                                className="w-28 h-24 rounded-lg"
                                              />
                                            )}

                                            {type === "pdf" && (
                                              <FileText
                                                size={36}
                                                className="text-red-600"
                                              />
                                            )}

                                            {type === "doc" && (
                                              <File
                                                size={36}
                                                className="text-blue-600"
                                              />
                                            )}

                                            {type === "file" && (
                                              <FileImage
                                                size={36}
                                                className="text-gray-600"
                                              />
                                            )}
                                          </div>

                                          <p>{item?.fileExt || "-"}</p>

                                          <a
                                            href={url}
                                            target="_blank"
                                            rel="noreferrer"
                                            download
                                            className="w-full text-center text-sm font-medium px-3 py-1.5 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-800 transition"
                                          >
                                            ⬇ Download
                                          </a>
                                        </div>
                                      );
                                    },
                                  )}
                              </div>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}

                  {/* Grand Total */}
                  <TableRow
                    sx={{
                      "& td": {
                        fontWeight: "bold",
                        fontSize: "16px",
                      },
                    }}
                  >
                    <TableCell colSpan={17} align="right">
                      Grand Total
                    </TableCell>

                    <TableCell>
                      ₹
                      {rows
                        .reduce(
                          (total, row) => total + (Number(row?.totalCost) || 0),
                          0,
                        )
                        .toLocaleString("en-IN")}
                    </TableCell>
                  </TableRow>
                </>
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={18}
                    align="center"
                    sx={{ fontWeight: "bold", py: 3 }}
                  >
                    No Wheel Alignment Log Details Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default Wheelalignmentdetails;
